<template>
  <page-template title="마이페이지">
    <div class="container-profile">
      <div class="wrapper-profile-image">
        <label for="input-profile-image">
          <img :src="profileImageUrl" alt="">
        </label>
        <input type="file" id="input-profile-image" ref="input-profile-image">
      </div>

      <div class="wrapper-profile-info" :style="{ height: isState('home') ? '170px' : isState('profile') ? '350px' : '270px' }">
        <div class="auth-info">
          <div class="master" v-if="editable.isMaster">Master</div>
          <div class="fc" v-if="editable.isFc">FC</div>
          <div class="store" v-if="editable.isStore">Store</div>
        </div>

        <home v-if="isState('home')" :name="editable.name" :phone="editable.phone" :email="editable.email">
          <button class="edit-profile" @click="toEditProfile">프로필 수정</button>
          <button class="reset-password" @click="toChangePassword">비밀번호 재설정</button>
        </home>

        <edit-profile v-else-if="isState('profile')"
                      :name="editable.name" :phone="editable.phone" :email="editable.email"
                      @name="value => editable.name = value" @phone="value => editable.phone = value" @email="value => editable.email = value">
          <button class="edit-profile" @click="toProfile">돌아가기</button>
          <button class="reset-password" @click="updateUser">완료</button>
        </edit-profile>

        <reset-password v-else
                        :password="editable.password" :confirm-password="editable.confirmPassword"
                        @password="value => editable.password = value" @confirmPassword="value => editable.confirmPassword = value">
          <button class="edit-profile" @click="toProfile">돌아가기</button>
          <button class="reset-password" @click="submitChangePassword">완료</button>
        </reset-password>

      </div>
    </div>
  </page-template>
</template>

<script>
import tempProfileImage from '@/assets/images/temp-profile-image.jpg';
import PageTemplate from '@/spa/components/page-template/PageTemplate';

import Home from './layouts/Home';
import EditProfile from './layouts/EditProfile';
import ResetPassword from './layouts/ResetPassword';

export default {
  name: 'ProfileComponent',

  components: {
    PageTemplate,
    Home,
    EditProfile,
    ResetPassword,
  },

  computed: {
    isFold() {
      return this.$store.getters.isFold;
    },
  },

  data() {
    return {
      editable: {
        id: null,
        name: '',
        phone: '',
        email: '',
        isMaster: false,
        isFc: false,
        isStore: false,
        password: '',
        confirmPassword: '',
      },

      profileImageUrl: null,

      editState: {
        home: true,
        profile: false,
        password: false,
      },

      prevState: 'home',
    };
  },

  methods: {
    changeState(state = 'home') {
      this.editState[this.prevState] = false;
      this.editState[state] = true;

      this.prevState = state;
    },

    isState(state) {
      return this.editState[state];
    },

    async toProfile() {
      this.editable = {
        id: this.$store.getters.user.id,
        name: this.$store.getters.user.name,
        phone: this.$store.getters.user.phone,
        email: this.$store.getters.user.email,
        isMaster: this.$store.getters.user.isMaster,
        isFc: this.$store.getters.user.isFc,
        isStore: this.$store.getters.user.isStore,
      };

      this.changeState('home');
    },

    toEditProfile() {
      this.changeState('profile');
    },

    toChangePassword() {
      this.editable.password = '';
      this.editable.confirmPassword = '';

      this.changeState('password');
    },

    async updateUser() {
      const result = await this.$store.dispatch('updateUserProfile', this.editable);

      this.$toast(result.message);
      if (result.response === null) return;

      this.editable.name = result.response.name;
      this.editable.phone = result.response.phone;
      this.editable.email = result.response.email;
    },

    async submitChangePassword() {
      const reg = /^(?=.*[a-zA-Z])((?=.*\d)|(?=.*\W)).{6,20}$/;

      const passwordTest = reg.test(String(this.editable.password).toLowerCase());
      const confirm = reg.test(String(this.editable.confirmPassword).toLowerCase());

      if (!passwordTest || !confirm) {
        this.$toast('비밀번호가 같지 않거나 규칙에 맞지 않습니다.');
        return;
      }

      const result = await this.$store.dispatch('changePassword', this.editable);


      this.$toast(result.message);
      if (result.response === null) return;
      this.toProfile();
    },
  },

  async created() {
    this.profileImageUrl = tempProfileImage;

    await this.toProfile();
  },
};

</script>

<style lang="scss" scoped>

.container-profile {
  width: 100%;
  height: auto;

  padding: 40px 32px;
  text-align: left;

  max-width: 500px;

  background-color: $color_white;

  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
  align-content: flex-start;

  flex-wrap: wrap;

  .wrapper-profile-image {
    input {
      display: none;
    }

    label {
      display: block;

      width: 110px;
      height: 110px;

      border-radius: 100px;
      overflow: hidden;
      img {
        width: 100%;
      }
    }
  }
  .wrapper-profile-info {
    position: relative;
    width: 100%;

    transition: height 0.2s ease-in-out;
    margin-top: 24px;

    .auth-info {
      display: flex;

      .master {
        @include color_text_button(144, 19, 254);
      }
      .fc {
        @include color_text_button(18, 38, 158);
      }
      .store {
        @include color_text_button(237, 144, 0);
      }
    }

    .user-info {
      margin-top: 12px;
      div {
        font-size: 16px;
        margin-bottom: 6px;
        &.name {
          font-size: 20px;
          margin-bottom: 12px;
        }
        &.phone, &.email {
          color: $nd60;
        }
      }
    }

    .edit-profile, .reset-password {
      font-size: 16px;
      padding: 14px 14px;
      border-radius: 4px;
      border: 1px solid $color_active_blue;
    }

    .edit-profile {
      color: $color_active_blue;
      background-color: transparent;
      margin-right: 16px;
    }

    .reset-password {
      color: $color_white;
      background-color: $color_active_blue;
    }
  }

  .wrapper-profile-edit {
    padding-top: 40px;
    width: 300px;
  }
}

.fade-in-enter-active{
  transition: all 0.5s;
}

.fade-in-leave-active {
  transition: all 0s;
}

.fade-in-enter {
  opacity: 0;
}

.fade-in-leave-to {
  opacity: 0;
}

@media screen and (max-width: 1024px) {
  .container-profile {
    flex-direction: column;

    justify-content: center;
    align-content: center;
    align-items: center;

    .wrapper-profile-info {
      margin: 0;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/spa/components/profile/ProfileComponent.vue